<template>
    <div
        class="container-top"
        :class="{'deep-black' : theme === 'deep-black'}"
        @click="handleMouseEnterOpen"
    >
        <div v-if="$store.state.is_global_select_menu" class="global-disbaled"></div>
        <div class="title">
            <!--<span class="iconfont icon-logo"></span>-->
            <p class="name">{{title}}</p>
            <el-dropdown v-if="isPreview" @command="handleCommand" @visible-change="handleSelect">
                <span
                    v-if="isMenu"
                    class="img-box iconfont icon-caidan1"
                    :class="{show: isSelectMenu}"
                >
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="me">我的课件</el-dropdown-item>
                    <el-dropdown-item command="add">新建课件</el-dropdown-item>
                    <el-dropdown-item command="help">使用帮助</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <div class="select-type-drop-box" v-if="isPreview">
                <ElementForm
                    :form="form"
                    @onAttr="onAttr"
                />
            </div>
            <div class="cocos-dev"
                 v-if="!isProd"
            >
                <ElementForm
                    :form="cocosForm"
                    @onAttr="onAttr"
                />
            </div>
        </div>
        <div class="newLesson-box">
            <div class="row-left">
                <div class="newLesson">
                    <div v-if="isShow" class="row-box">
                        <span v-if="!isEditName" class="name">课件名称： {{newLesson.name}}</span>
                        <span v-else class="name" >课件名称：
                            <el-input
                                size="mini"
                                class="edit-input"
                                v-model="newLesson.name"
                                @focus="setSendKeyBoardToCocos({key: 'lessonName', value: false})"
                                @blur="setSendKeyBoardToCocos({key: 'lessonName', value: true})"
                            ></el-input>
                        </span>
                        <p class="row" v-if="isEdit && !isPractice">
                            <span v-if="!isEditName" class="edit-name iconfont icon-pen" @click="editLessonName(newLesson.name)"></span>
                            <span v-else class="btn-box">
                            <span
                                    class="btn save"
                                    @click="editLessonNameApi(newLesson.name)"
                            >保存</span>
                            <span
                                    class="btn cancel"
                                    @click="editLessonNameCancel"
                            >取消</span>
                        </span>
                        </p>
                    </div>


                    <span v-if="isShow" class="line" :class="{preview: !isEdit, none: isPractice}"></span>


                    <div v-if="isShow" class="row-box">
                        <span class="name" v-if="!isEditTitle">课件标题： {{newLesson.title}}</span>
                        <span v-else>课件标题：
                            <el-input
                                size="mini"
                                class="edit-input"
                                v-model="newLesson.title"
                                @focus="setSendKeyBoardToCocos({key: 'lessonTitle', value: false})"
                                @blur="setSendKeyBoardToCocos({key: 'lessonTitle', value: true})"
                            ></el-input>
                        </span>
                        <p class="row" v-if="isEdit && !isPractice">
                            <span v-if="!isEditTitle" class="edit-title iconfont icon-pen" @click="editLessonTitle(newLesson.title)"></span>
                            <span v-else class="btn-box">
                                <span
                                        class="btn save"
                                        @click="editLessonTitleApi(newLesson.title)"
                                >保存</span>
                                <span
                                        class="btn cancel"
                                        @click="editLessonTitleCancel"
                                >取消</span>
                            </span>
                        </p>
                        <span v-if="isShow" class="line" :class="{preview: !isEdit, none: isPractice}"></span>
                        <span class="updateState">{{updateState}}</span>
                    </div>

                    <!--练习名称-->
                    <div class="row-box" v-if="isPractice">
                        <span class="line" :class="{preview: !isEdit, none: isPractice}"></span>
                        <span class="name" v-if="!isEditPracticeName">练习名称： {{newLesson.practiceName}}</span>
                        <span v-else>练习名称：
                            <el-input
                                    size="mini"
                                    class="edit-input"
                                    v-model="newLesson.practiceName"
                                    @focus="setSendKeyBoardToCocos({key: 'lessonPracticeName', value: false})"
                                    @blur="setSendKeyBoardToCocos({key: 'lessonPracticeName', value: true})"
                            ></el-input>
                        </span>
                        <p class="row" v-if="isEdit">
                            <span v-if="!isEditPracticeName"
                                  class="edit-title iconfont icon-bianji_heise"
                                  @click="editLessonPracticeName(newLesson.practiceName)"></span>
                            <span v-else class="btn-box">
                            <span
                                    class="btn save"
                                    @click="editLessonPracticeNameApi(newLesson.practiceName)"
                            >保存</span>
                            <span
                                    class="btn cancel"
                                    @click="editLessonPracticeNameCancel"
                            >取消</span>
                        </span>
                        </p>
                        <span class="line" :class="{preview: !isEdit, none: isPractice}"></span>
                        <ElementForm
                            v-if="isPractice"
                            :form.sync="practiceOptions"
                            @onAttr="onAttrPractice"
                        />
                    </div>

                </div>
            </div>
        </div>
        <div class="btns-content">
            <div v-if="isRemark" class="btns-box">
                <!--<el-button class="btn active" @click="back" size="medium">返回</el-button>-->
                <!--                <button class="btn active" @click="onRemark">查看备注</button>-->
            </div>
            <div v-else class="btns-box">
                <PPTStatus
                    v-if="$store.state.pptData.length>0 && isEditPage"
                    theme="deep-black"
                    :data.sync="$store.state.pptData"
                    @flashPPT="$emit('flashPPT')"
                />
                <span class="gap"></span>
                <button class="btn" @click="save">保存</button>
                <button class="btn" @click="preview">预览</button>
                <button
                        v-if="`${$route.query.is_template}` !== 'true' && `${$store.state.initConfig.school_id}`!=='0'"
                        class="btn" @click="send">发布</button>
                <button class="btn" @click="quit">退出</button>
            </div>
        </div>
        <TopMenus :title="title" :show.sync="topMenuIsShow" />
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import PPTStatus from '../contents/components/pptUploadStatus'
    import TopMenus from './components/menus'
    import * as GlobalServer from '../../../../api/global'
    import Config from '../../../../config/app'

    export default {
        name: "top",
        components: {
            TopMenus,
            PPTStatus
        },
        props: {
            // 主题
            theme: {
                type: String
            },
            // 是否存在一个模块类别
            isHasOneMenu: {
                type: Boolean,
                default: true
            },
            // 是否可编辑
            isEdit: {
                type: Boolean,
                default: true
            },
            // 判断是否是游戏练习
            isPractice: {
                type: Boolean,
                default: false
            },
            // 是否有菜单
            isMenu: {
                type: Boolean,
                default: false
            },
            // 是否备注
            isRemark: {
                type: Boolean,
                default: false
            },
            lesson: {
                type: Object,
                default: ()=>{
                    return {
                        type: 'online',
                        name: '高级课件器',
                        title: '高级课件器',
                        practiceName: '练习名称'
                    }
                }
            },
            practiceScene: [String, Object]
        },
        computed: {
            isProd(){
                return Config.domain === 'yunkedun.com'
            },
            // 默认显示，如果是练习且课件id不存在则隐藏
            isShow(){
                let state = true
                if(this.isPractice){
                    state = false
                }
                return state
            },
            isPreview(){
                return !this.isPractice && this.$route.path !== '/preview'
            },
            // 当前是否编辑页面
            isEditPage(){
                return this.$route.path === '/main'
            },
        },
        watch:{
            practiceScene(vl){
                try {
                    let newVl = vl
                    if(typeof newVl === 'string' && newVl.length>1){
                        newVl = JSON.parse(newVl)
                    }
                    this.newPracticeScene = newVl
                    if(newVl && newVl.key){
                        const typeIndex = this.$utils.getIndexByAttr({attr: 'type', data: this.practiceOptions})
                        if(typeIndex>-1) this.practiceOptions[typeIndex].value = newVl.key
                    }
                } catch (e) {
                    console.log('practiceScene转换失败==>', e)
                }
            },
            newPracticeScene(vl){this.$emit('update:practiceScene', vl)},
            lesson(vl){this.newLesson = vl},
            newLesson:{
                handler(vl) {
                    this.$emit('update:lesson', vl)
                    let index =  this.$utils.getIndexByAttr({attr:'type', data: this.form})
                    this.form[index].value = vl.type
                },
                deep: true,
                immediate: true
            },
            '$store.state.cocos_global_common': {
                handler(vl){
                    if(vl && Object.keys(vl).length){
                        let arr = []
                        for(let item in vl){
                            if(item.indexOf('Remark')>-1 && item.indexOf('khlx-theme')>-1){
                                arr.push(vl[item])
                            }
                        }
                        let newForm = this.$_.cloneDeepWith(this.practiceOptions)
                        let typeIndex = this.$utils.getIndexByAttr({attr: 'type', data: newForm})
                        if(typeIndex>-1){
                            newForm[typeIndex].options = arr
                            this.practiceOptions = newForm
                        }
                    }
                },
                deep: true,
                immediate: true
            },
            '$store.state.updateState': {
                handler(vl){
                    if(vl && Object.keys(vl).length){
                        this.updateState=vl
                    }
                },
                deep: true,
                immediate: true
            },
            isHasOneMenu: {
                handler(vl){
                    if(vl && !this.practiceOptions[0].value && this.practiceOptions[0].options && this.practiceOptions[0].options[0]){
                        const key = this.practiceOptions[0].options[0].key
                        this.practiceOptions[0].value = key
                        const cocos_style = this.$store.state.cocos_global_common[key]
                        this.newPracticeScene = {key,value: cocos_style}
                        this.$emit('onPracticeScene')
                    }
                },
                deep: true,
                immediate: true
            }

        },
        created(){
            this.init()
            // window.onbeforeunload=function(event){
            //     //跳转页面或刷新页面会产生提示信息
            //     if(document.all){
            //         alert(1)
            //         if(event.clientY < 0){
            //             return "1确定要离开吗？";
            //         }
            //     }else{
            //         alert(2)
            //         return "2确定要离开吗？";
            //     }
            // }
        },
        data(){
            return {
                newPracticeScene: this.practiceScene,
                isSelectMenu: false, // 是否正在操作 云课盾更多
                isEditName: false,
                isEditTitle: false,
                isEditPracticeName: false,
                updateState:this.$store.state.updateState,
                form: [
                    {
                        attr: 'type',
                        "name": "",
                        "value": this.$store.state.curClassType,
                        "type": "Select",
                        "props": {
                            "placeholder": "请选择",
                            "rules": {
                                "required": false,
                                "message": "请输入",
                                "target": "请选择"
                            },
                            size: 'mini'
                        },
                        "options": [
                            {
                                "key": "online",
                                "value": "线上课件"
                            },
                            {
                                "key": "offline",
                                "value": "线下课件"
                            },
                            {
                                "key": "double_teacher",
                                "value": "双师课件"
                            }
                        ]
                    }
                ],
                cocosForm: [
                    {
                        attr: 'dev',
                        "name": "",
                        "value": this.$store.state.curCocosDevUrl,
                        "type": "Select",
                        "props": {
                            "placeholder": "请选择cocos版本",
                            "rules": {
                                "required": false,
                                "message": "请输入",
                                "target": "请选择"
                            },
                            size: 'mini',
                            clearable: true,
                            filterable: true
                        },
                        "options": []
                    }
                ],
                title: '课件平台',
                newLesson: this.lesson,
                // 顶部菜单是否展开
                topMenuIsShow: false,
                // 练习类型
                practiceOptions: [
                    {
                        attr: 'type',
                        "name": "",
                        "value": "",
                        "type": "Select",
                        "props": {
                            "placeholder": "请选择练习场景",
                            "rules": {
                                "required": false,
                                "message": "",
                                "target": "blur"
                            },
                            size: 'small'
                        },
                        "options": []
                    }
                ]
            }
        },
        methods: {
            ...mapActions(['setSendKeyBoardToCocos']),
            init(){
                if(Config.domain !== 'yunkedun.com') {
                    this.getCocosPackList()
                }
            },
            async getCocosPackList(){
                try {
                    const res = await GlobalServer.getCocosPackList({versionOrder: 'desc'})
                    const arr = res.items.map(v=>{
                        return {
                            key: v?.attach?.unpack_url,
                            value: v.version
                        }
                        })
                    const cocosIndex = this.$utils.getIndexByAttr({attr: 'dev', data: this.cocosForm})
                    this.cocosForm[cocosIndex].options = arr
                } catch (e) {
                    console.log('获取cocos包列表失败==>', e)
                }
            },
            // 选中云课盾 更多操作
            handleSelect(state) {
                this.isSelectMenu = state
            },
            editLessonName(name){
                if (!this.isEdit) {
                    return false
                }
                console.log('编辑名称==>', name)
                this.newLesson['oldName'] = name
                this.isEditName = true

            },
            editLessonNameApi(name){
                if(!name || !name.trim()){
                    this.$message({type: 'error',message:'名称不能为空', duration: 1000})
                    return false
                }else {
                    this.isEditName = false
                    this.editInfo()
                }
            },
            editInfo(){
                this.$emit('oldSave', false, null)
            },
            editLessonNameCancel (){
                this.newLesson.name = this.newLesson.oldName
                this.isEditName = false
            },
            editLessonTitle(title){
                if (!this.isEdit) {
                    return false
                }
                console.log('编辑标题==>', title)
                this.newLesson['oldTitle'] = title
                this.isEditTitle = true
            },
            editLessonTitleApi(title){
                if(!title || !title.trim()){
                    this.$message({type: 'error',message:'标题不能为空', duration: 1000})
                    return false
                }else {
                    this.isEditTitle = false
                    this.editInfo()
                }
            },
            editLessonTitleCancel(){
                this.newLesson.title = this.newLesson.oldTitle
                this.isEditTitle = false
            },
            editLessonPracticeName(practiceName){
                if (!this.isEdit) {
                    return false
                }
                console.log('编辑练习名称==>', practiceName)
                this.newLesson['oldPracticeName'] = practiceName
                this.isEditPracticeName = true
            },
            editLessonPracticeNameApi(practiceName){
                if(!practiceName || !practiceName.trim()){
                    this.$message({type: 'error',message:'练习名称不能为空', duration: 1000})
                    return false
                }else {
                    this.isEditPracticeName = false
                    this.editInfo()
                }
            },
            editLessonPracticeNameCancel(){
                this.newLesson.practiceName = this.newLesson.oldPracticeName
                this.isEditPracticeName = false
            },
            onAttr(data, value){
                console.log('切换课程==>', data, value)
                switch (data.attr) {
                    case 'type': {
                        let index = this.$utils.getIndexByAttr({attr: 'type', data: this.form})
                        this.newLesson.type = this.form[index].value
                        this.$store.state.curClassType = this.newLesson.type
                        console.log('类型选中==>', this.$store.state.curClassType)
                        break
                    }
                    case 'dev': {
                        this.$store.state.curCocosDevUrl = value
                        break
                    }
                    default:
                }
            },
            onAttrPractice(data, key){
                switch (data.attr) {
                    case 'type': {
                        const cocos_style = this.$store.state.cocos_global_common[key]
                        this.newPracticeScene = {key,value: cocos_style}
                        const operation = [{node: 'parent', data: this.newPracticeScene, operation: 'cocos_style'}]
                        $eventBus.$emit('__save__',true, null, operation)
                        this.$emit('onPracticeScene')
                        break
                    }
                    default:
                }
            },
            // 顶部菜单是否展示
            handleTopMenusIsShow(){
                this.topMenuIsShow = !this.topMenuIsShow
            },
            // 返回
            back(){
                this.$RouteUtil.main({...this.$route.query})
            },
            // 备注
            onRemark(){
                this.$emit('onRemark')
            },
            // 预览
            preview(){
                this.$emit('preview')
            },
            // 保存
            save(){
                this.beforeOperate(()=>this.$emit('save'))
                // this.$emit('save')
            },
            // 发布
            send(){
                this.beforeOperate(()=>this.$emit('send'))
                // this.$emit('send')
            },
            beforeOperate (fn) {
                // 如果正在编辑课件名称 或 标题 提示正在编辑中
                if (this.isEditName) {
                    this.$message.error('当前正在编辑课件名称')
                    return false
                } else if (this.isEditTitle) {
                    this.$message.error('当前正在编辑课件标题')
                    return false
                } else if (this.isEditPracticeName) {
                    this.$message.error('当前正在编辑练习名称')
                    return false
                }
                fn && fn()
            },
            // 退出
            quit(){
                // 如果是来自客户端 则返回列表页
                if (this.$route.query.fromPlat === 'window'){
                    this.$RouteUtil.template({...this.$route.query})
                    return false
                }
                this.$confirm('你确定要退出编辑器?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$emit('quit')
                })
            },
            handleCommand (command) {
                console.log('指令==>', command)
                switch (command) {
                    case 'me':
                        this.$RouteUtil.template({...this.$route.query, isEdit: true})
                        break;
                    case 'add': {
                        let obj = {
                            school_id: this.$store.state.initConfig.school_id,
                            category_id: this.$store.state.initConfig.category_id
                        }
                        if (this.$store.state.initConfig.is_template) obj['is_template'] = true
                        if (this.$store.state.initConfig.is_shop) obj['is_shop'] = true
                        this.$RouteUtil.main({...this.$route.query, ...obj, id: ''})
                        window.location.reload()
                        break;
                    }
                    case 'help':
                        break;
                    default:
                }
            },
            handleMouseEnterOpen(){
                this.$store.state.menusKeyBoard=false;//当前是可操作焦点
            },
        }
    }
</script>
<style>
.row-left .isRequired{
    margin-bottom: 0px !important;
  }
.select-type-drop-box .el-form-item__content{
    margin-top: 20px;
    margin-left: 26px;
}
.cocos-dev .el-form-item__content{
    margin-top: 20px;
    margin-left: 10px;
}
.select-type-drop-box {
    position: relative;
    display: none;
}
.select-type-drop-box:before{
    content: '';
    position: absolute;
    top: 34px;
    left: 16px;
    width: 1px;
    height: 14px;
    background-color: #eee;
}
.deep-black .select-type-drop-box:before{
    background-color: #4A4E59;
}
*:focus{
    outline: none !important;
}
</style>
<style lang="scss" scoped>
.container-top{
    display: flex;
    flex-direction: row;
    height: 54px;
    line-height: 54px;
    background:rgba(255,255,255,1);
    box-shadow:0px 0px 2px 0px rgba(0, 0, 0, 0.17);
    z-index: 1002;
    position: relative;

    .btns-content {
        min-width: 264px;
        margin-right: 20px;

        .btns-box{
            display: flex;
            flex-direction: row;
            align-items: center;
            height: 55px;

            .gap{
                margin-left: 20px;
                margin-right: 20px;
                width: 1px;
                height: 14px;
                background: #dcdfe6;
                position: relative;
                top: 0px;
            }
            .btn{
                background-color: initial;
                border: none;
                outline: none;
                cursor: pointer;
                height: 26px;
                line-height: 18px;
                border-radius:16px;
                transition: all .3s linear;
                font-size:14px;
                font-weight:400;
                color:rgba(48,49,51,1);
                line-height:20px;
                margin-left: 20px;
                margin-right: 13px;
            }
            .btn.active,.btn:hover{
                color: #e7622e;
            }
        }
    }

    .title{
        display: flex;
        flex-direction: row;
        /*width: 450px;*/
        align-items: center;
        /*box-shadow:0px 0px 3px 0px rgba(0, 0, 0, 0.17);*/

        .select-box{
            height: 100%
        }
        .img-box{
            user-select: none;
            outline: none !important;
            margin-left: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            font-size: 16px;

            background: #36383F;
            height: 30px;
            padding: 0px 6px;
            border-radius: 4px;
            color: #BDBEC7;

            &.show{
                color: #e7622e;
            }
        }
        .name{
            margin-left: 16px;
            font-size:18px;
            font-weight:500;
            color:rgba(48,49,51,1);
            line-height:25px;
        }
    }

    .newLesson-box{
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: center;

        .row-left{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
        }

        .newLesson{
            font-size:14px;
            color:rgba(51,51,51,1);
            margin-left: 40px;
            user-select: none;
            display: flex;
            flex-direction: row;
            align-items: center;

            .row{
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            .row-box{
                display: flex;
                flex-direction: row;
                align-items: center;
            }

            .edit-name,.edit-title{
                font-size: 12px;
                margin: 0px 10px;
                cursor: pointer;
            }
            .edit-name{
                margin-right: 20px;
            }
            .line{
                width: 1px;
                height: 14px;
                background-color: #eee;
                display: inline-block;
                position: relative;
                margin-right: 14px;
                top: 2px;

                &.none{
                    background-color: initial;
                }

                &.preview{
                    margin-left: 14px;
                    top:0px;
                }
            }
            .updateState{
                color:#B25836;
            }
            .name{
                /*margin-right: 30px;*/
                line-height: 18px;
            }
            .edit-input{
                width: 160px;
            }
            .btn-box{
                margin: 0px 10px;
                font-size:14px;
                font-weight:400;
                color:rgba(144,147,153,1);
                line-height:20px;

                .btn {
                    cursor: pointer;

                    &:hover {
                        color: #e7622e;
                    }
                }
                .save{
                    margin-right: 10px;
                }
            }
        }
    }
    .title{
        .icon-logo{
            margin-left: 20px;
        }
    }
    &.deep-black{
        background-color: #222328;

        .title{

            .icon-logo{
                color: #BDBEC7;
                margin-left: 20px;
                font-size: 14px;
            }
            .name {
                color: #BDBEC7;
                font-size: 14px;
                margin-left: 4px;
            }
        }
        .newLesson-box {
            justify-content: flex-start;

            .newLesson{
                margin-left: 20px;
                color: #BDBEC7;

                .line{
                    background-color: #4A4E59;
                    top: 0px;
                }
            }
        }

        .btns-content{
            margin-right: 4px;

            .btns-box{
                .gap{
                    background-color: #4A4E59;
                }
                .btn{
                    padding: 5px 12px;
                    font-size: 14px;
                    height: initial;
                    line-height: 20px;
                    color: #BDBEC7;
                    background: #393B42;
                    border-radius: 4px;
                    margin-left: 0px;
                    margin-right: 12px;

                    &:hover{
                        background-color: #724B3C;
                    }
                }
            }
        }
    }
}
</style>
